import { AxiosInstance } from 'axios';

import { PACKAGE_STATES } from '@/model/Logistic/PackageStates';
import { Shipment } from '@/model/Logistic/Shipment/Shipment';

class ShipmentApi {
  axiosInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  async updateShipmentState(shipmentId: number, newState: PACKAGE_STATES) {
    try {
      const response = await this.axiosInstance.patch(`/shipments/${shipmentId}`, {
        status: newState,
      });

      return response.data;
    } catch (error) {
      console.error('Error updating shipment state:', error);
      throw error;
    }
  }

  async updateShipmentTrackingNumber(shipmentId: number, trackingNumber: string) {
    try {
      const response = await this.axiosInstance.patch(`/shipments/${shipmentId}`, {
        tracking_number: trackingNumber,
      });

      return response.data;
    } catch (error) {
      console.error('Error updating shipment tracking number:', error);
      throw error;
    }
  }

  async updateShipmentExternalDocument(shipmentId: number, externalDocument: string) {
    try {
      const response = await this.axiosInstance.patch(`/shipments/${shipmentId}`, {
        external_document: externalDocument,
      });

      return response.data;
    } catch (error) {
      console.error('Error updating shipment external document:', error);
      throw error;
    }
  }

  async updateShipment(shipmentId: number, shipmentData: Partial<Shipment>) {
    try {
      const response = await this.axiosInstance.patch(`/shipments/${shipmentId}`, {
        ...shipmentData,
      });

      return response.data;
    } catch (error) {
      console.error('Error updating shipment external document:', error);
      throw error;
    }
  }
}

export default ShipmentApi;
